import Button from "@components/button/button";
import { ButtonSize, buttonTheme } from "@components/button/button-constants";
import { useLink } from "@components/link/link-helpers";

import { newCareerTrackPath } from "./helpers";

// Company-wide competencies can be written before any track exists, but
// nobody holds a role until one does: say so, with the way forward. Shown on
// the overview and on All Tracks.
const NoTracksNotice = ({ organizationId }: { organizationId: number }) => {
  const link = useLink();
  return (
    <div
      // The grey of the page's other empty states ("No competencies yet.").
      className="flex items-center justify-between gap-4 mb-3 shrink-0 rounded-md bg-gray-100 px-4 py-3"
      aria-label="No career tracks notice"
    >
      <div className="text-sm">
        <div className="font-medium text-gray-900">
          No career tracks created yet
        </div>
        <div className="text-gray-500">
          There are no roles available until a career track is created.
        </div>
      </div>
      <Button
        theme={buttonTheme.primary}
        size={ButtonSize.medium}
        text="Create Track"
        aria-label="Create track from notice"
        onClick={() => link.redirect(newCareerTrackPath(organizationId))}
      />
    </div>
  );
};

export default NoTracksNotice;
